module.exports = __webpack_public_path__ + "static/media/eireng.62964a2c.png";